import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { getRandomInt, randomString, getCDate, check, sleep, genKey } from '@/customFunction';
const headers = {'Accept': 'application/json'};
import router from '../router'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    site: {
      "avatar": "https://firebasestorage.googleapis.com/v0/b/cip-generic.appspot.com/o/default-user.png?alt=media&token=82389d15-0419-4d2c-8b5e-5fe3e18c3ca7",
      "language": "en",
      "logo": "/aramcco.png", // "/mcit_okrtool/mcit-logo.png",
      "name": "ARAMCCO GERMANY | CRM | ERP",
      "theme": {
        "light": {
          "accent": "#102944",
          "error": "#FF5252",
          "info": "#2196F3",
          "primary": "#104b91",
          "secondary": "#950e0e",
          "success": "#4CAF50",
          "warning": "#FFC107"
        }
      }
    },
    access_token: null,
    last_click:null,
    lock_:null,
    unlock_:null,
    i18n: {
      en: {
        //// nav
        emailSoftware:`Emails System`,
        campaigns:`Campaigns`,
        campaign:`Campaign`,
        lists:`Lists`,
        list:`List`,
        templates:`Templates`,
        template:`Template`,
        accountCreated:`Account Created, Contact Admin To Grant Access`,
        sent:`Sent`,
        opened:`Opened`,
        clicked:`Clicked`,
        lastChange:`Last Change`,
        agent:`Employee`,
        access:`Access`,
        userRole: `User Role`,
        user: `User`,
        users: `Users`,
        admin: `Admin`,
        superadmin: `Super Admin`,
        userEmail: `User Email`,
        userName: `Username`,
        close: `Close`,
        position: `Position`,
        submitBtn: `Save`,
        reload: `reload`,
        subject: `Subject`,
        fromName: `From Name`,
        fromEmail: `From Email`,
        replyTo: `Reply To`,
        lastUpdated: `Last Updated`,
        sendingActive: `Sending...`,
        inDraft: `Draft`,
        alreadySent: `Sent`,
        sendIconTooltip: `Send Now`,
        scheduleIconTooltip: `Send Later`,
        valid_email: `Please enter a valid Email`,
        leads: `Leads`,
        subscribers: `Subscribers`,
        suppressions: `Supression`,
        offices: `Offices`,
        create:`Create`,
        areYouSureOfDelete:`Are you sure you want to delete |item|, this cant be restored!`,
        deleteBtn:`Delete`,
        interviews:`interviews`,
        automation:`Automation`,
        delay: `Delay`,
        delay_unit: `Delay Unit`,
        company:`Company`,
        time:`Time`,
        day:`Day`,
        days:`Days`,
        company_address:`Company address`,
        conditions:`Conditions`,
        google_map:`Google map`,
        day_language:`Day language`,
        promo_text:`Promo text`,
        language:`Language`,
        programs:`Programs`,
        phones:`Phones`,
        subject:`Subject`,
        limit:`Count To Send`,
        program:`Program`,
        emails:`Emails`,
        delivered:`Delivered`,
        opened:`Opened`,
        clicked:`Clicked`,
        bounced:`Bounced`,
        pleaseEnterPin:`Please Enter Pin`,
        pin:`Pin`,
        continue:`Continue`,
        edit:`Edit`,
        country:`Country`,
        phone:`Phone`,
        status:`Status`,
        note:`Note`,
        user:`Employee`,
        program_name:`program`,
        country_name:`country`,
        user_name:`employee`,
        status_name:`status`,
        source:`Source`,
        settings: `Settings`,
        countries:`Countries`,
        statuses:`Statuses`,
        AddItem:`Add item`,
        french:`French`,
        duplicate:`Duplicate`,
        userCountries:`User countries`,
        userPrograms:`User Programs`,
        userRoles:`User Roles`,
        hq:`Head Quarter`,
        branchManager:`Branch Manager`,
        programManager:`Program Manager`,
        assign:`Assign Leads`,
        assignRatio:`Assign Ratio`,
        save:`Save`,
        update:`Update`,
        appointment: 'Appointment',
        pinRepeat: 'Repeat Pin',
        pinNew: 'New Pin',
        changePin: 'Change Pin',
        leadsManagment: 'Leads Management',
        reassignLeads: 'Reassign Leads',
        forms:`Lead Forms`,
        form_id:`FORM ID`,
        /////////////
        captcha:`Please enter the code in the picture above`,
        wrong_captcha: `You have entered a wrong code`,
        only_numbers:`Only numbers allowed`,
        progressTitle:`Progress`,
        pdfReportsIconTooltip: `Generate Report`,
        generateReport:`Generate Report`,
        clearChart: `Clear Chart`,
        cant_be_imported:`User cant be imported`,
        domain_not_allowed: `Domain is not allowed`,
        allLegend: `Threshold Legend`,
        specialAccess: `Give user special access to ministry pages`,
        email: `Email`,
        password: `Password`,
        home: `Home`,
        login: `Login`,
        send: `send`,
        max_retries: `Max retries reached`,
        wrong_code: `Wrong code`,
        expired: `Expired`,
        user_already_exists: `User already exists`,
        success: `Success`,
        not_found: `Item Not found`,
        all_fields_required: `All fields required`,
        item_name_missing: `An item name is missing`,
        organisation: `Ministry Overview`,
        strategy: `Ministry Strategy`,
        orgProgress: `Ministry Progress`,
        orgStructure: `Ministry Org. Structure`,
        userSettings:`User Settings`,
        mySpace: `My Data`,
        notifications: `Notifications`,
        approvals: `Approval`,
        progress: `Progress`,
        reports: `Reports`,
        report: `Report`,
        managment: `Management`,
        employees: `Import Employees`,
        employeesSub: `Employee Management`,
        charts: `Performance Charts`,
        approvals: `Approvals`,
        orgStructureSetting: `Ministry Org. Structure Settings`,
        logout: `Log out`,
        pubReports: `Publish Reports`,
        ////// progress
        search:`Search`,
        totalProgress:`Total Progress`,
        goals: `Objectives`,
        goal: `Objective`,
        keyResult:`Key Result`,
        keyResults:`Key Results`,
        initiative: `Initiative`,
        initiatives:`Initiatives`,
        trend: `Variance`,
        progress: `OKRs`,
        mainResult: `KRs/Initiatives`,
        status: `Status`,
        change: `Edit`,
        editIconTooltip: `Edit`,
        deleteIconTooltip: `Delete`,
        trending: {
          up: `Up`,
          down: `Down`,
          flat: `Stable`
        },
        addGoal: `Add Objective`,
        addGoalTitle: `Add Objective`,
        editGoalTitle: `Edit Objective`,
        parentGoal:`Parent Objective`,
        deleteGoalTitle: `Delete Objective`,
        addKeyResult: `Add Key Result`,
        addKeyResultTitle: `Add Key Result`,
        editKeyResultTitle: `Update Key Result`,
        deleteKeyResultTitle: `Delete Key Result`,
        addInit: `Add Initiative`,
        addInitTitle: `Add Initiative`,
        editInitTitle: `Edit Initiative`,
        deleteInitTitle: `Delete Initiative`,
        viewGoalTitle: `Objective Details`,
        viewKeyResultTitle: `Key Result Details`,
        viewInitTitle: `Initiative Details`,
        cancelBtn: `cancel`,
        addBtn: `add`,
        updateBtn: `Update`,
        add: `Add`,
        update: `Update`,
        delete: `Delete`,
        deleteMessage: `Are you sure you want to remove this item and all related items?`,
        startValue:`Start Value`,
        targetValue:`Target Value`,
        unite:`Unit`,
        currentValue:`Current Value`,
        weight: `Weight`,
        quarter: `Quarter`,
        meters: `Meter`,
        dollar: `US Dollar`,
        riyal: `Saudi Riyal`,
        rank: `Rank`,
        number: `Number`,
        mbps: `Mbps`,
        gbps: `Gbps`,
        percentage: `%`,
        quarter_one: `First Quarter`,
        quarter_two: `Second Quarter`,
        quarter_three: `Thrid Quarter`,
        quarter_four: `Fourth Quarter`,
        required: `Required`,
        upload: `Upload`,
        confidential: `Confidential`,
        normal: `Normal`,
        fileType: `File Type`,
        files: `Supporting Documents`,
        date: `Date`,
        new: `New`,
        theVision: `Vision`,
        theMission: `Mission`,
        theMessage: `Message`,
        usersSettings: `User Role Settings`,
        updateUser: `Update User`,
        platformSettings: `Platform Settings`,
        thresholdSettings: `Threshold Settings`,
        uniteSettings: `Unit Settings`,
        fileTypeSettings: `Supporting Documents’ Classification Settings`,
        allowedFilesSettings: `Allowed Files Settings`,
        AddThreshold: `Add a threshold`,
        name: `Name`,
        percentageWord: `Percentage`,
        saveSetting: `Save Settings`,
        slug: `Slug (no space)`,
        arabic: `Arabic`,
        english: `English`,
        AddUnite: `Add unit`,
        hundredError: `Must be less than 100`,
        AddFileType: `Add classification`,
        
        addMainLevel: `add main item`,
        addBelow: `add sub item`,
        phoneNumber: `Phone`,
        importUser: `Import User & Open an account`,
        employeeData: `Employee Data`,
        employee: `Employee`,
        accept: `Accept`,
        type: `Type`,
        reject: `Reject`,
        rejectMessage: `Rejection Note`,
        acceptedNotification: `Acceptance issued for`,
        rejectNotification: `Rejection issued for`,
        submissionNotification: `submitted for review`,
        deletionNotification: `Deleted`,
        pending:`Pending`,
        approved: `Approved`,
        there: `A`,
        createNewReport: `Create a new report`,
        dones: `Achievements`,
        todos: `Plans`,
        supports: `Problems`,
        comments: `Comments`,
        reportName: `Report Name`,
        fromDate: `From Date`,
        toDate: `To Date`,
        newReportNotification: `New Report`,
        by: `by`,
        submitReport: `Submit Report`,
        deleteReport: `Delete Report`,
        updateReport: `Update Report`,
        myReports: `My Reports`,
        employeesReports: `Employee Reports`,
        uniteThresholds: `Use single set of rules for all objects`,
        all: `All`,
        totals: `Totals`,
        stepName: `Threshold Name`,
        stepSettings: `Threshold Settings`,
        instituteSettings: `Edit Ministry Strategy`,
        lastSeen: `Last Update`,
        getEmailNotifications: `Get OKR notifications by email`,
        getReportsByEmail: `Get Reports notifications by email`,
        user_does_not_exist: `User does not exist`,
        viewIconTooltip: `View details`,
        reportsIconTooltip: `View Reports`,
        closeBtn: `Close`,
        SMSCode: `SMS Code`,
      },
      ar: {
        //// nav
        emailSoftware:`الايميلات`,
        campaigns:`الحملات`,
        campaign:`حملة`,
        lists:`القوائم`,
        list:`قائمة`,
        templates:`القوالب`,
        template:`قالب`,
        accountCreated:`تم انشاء الحساب تواصل مع المدير للسماح لك بالدخول`,
        sent:`ارسال`,
        opened:`فتح`,
        clicked:`نقر`,
        lastChange:`اخر تحديث`,
        agent:`الموظف`,
        access:`الدخول`,
        userRole: `نوع المستخدم`,
        users: `مستخدمين`,
        user: `المستخدم العادي`,
        admin: `مدير`,
        superadmin: `مدير عام`,
        userEmail: `ايميل المستخدم`,
        userName: `اسم المستخدم`,
        close: `اغلاق`,
        position: `المسمى الوظيفي`,
        submitBtn: `تخزين`,
        reload: `اعادة تحميل`,
        subject: `العنوان`,
        fromName: `اسم المرسل`,
        fromEmail: `ايميل المرسل`,
        replyTo: `الردود الى`,
        lastUpdated: `اخر تحديث`,
        sendingActive: `جاري الارسال...`,
        inDraft: `مسودة`,
        alreadySent: `تم ارسال`,
        sendIconTooltip: `ارسال الان`,
        scheduleIconTooltip: `الارسال لاحقاً`,
        valid_email: `يرجى ادخال ايميل صحيح`,
        leads: `الطلبات`,
        subscribers: `ايميلات الملتحقين`,
        suppressions: `منع الارسال`,
        offices: `المكاتب`,
        create:`انشاء جديد`,
        areYouSureOfDelete:`هل انت متأكد بانك تريد حذف |item| بشكل نهائي؟`,
        deleteBtn:`مسح`,
        interviews:`المقابلات`,
        automation:`اتمتة`,
        delay: `كمية التأجيل`,
        delay_unit: `الوحدة`,
        programs:`البرامج`,
        phones:`ارقام هواتف`,
        subject:`العنوان`,
        limit:`العدد`,
        program:`البرنامج`,
        emails:`الايميلات`,
        delivered:`وصل`,
        opened:`فتح`,
        clicked:`نقر`,
        bounced:`باونس`,
        pleaseEnterPin:`الرجاء ادخال الرقم السري`,
        pin:`الرقم السري`,
        continue:`اكمال الجلسة`,
        edit:`تعديل`,
        country:`الدولة`,
        phone:`رقم الهاتف`,
        status:`الحالة`,
        note:`ملاحظة`,
        user:`موظف`,
        program_name:`البرنامج`,
        country_name:`الدولة`,
        user_name:`الموظف`,
        status_name:`الحالة`,
        source:`المصدر`,
        countries:`الدول`,
        statuses:`الحالات`,
        AddItem:`اضافة`,
        french:`فرنسي`,
        duplicate:`مكرر`,
        userCountries:`دول الموظف`,
        userPrograms:`برامج الموظف`,
        userRoles:`انواع المستخدم`,
        hq:`الفرع الرئيسي`,
        branchManager:`مدير فرع`,
        programManager:`مدير برنامج`,
        assign:`توزيع الطلبات`,
        assignRatio:`نسبة التوزيع`,
        save:`تخزين`,
        update:`تحديث`,
        appointment: 'الموعد',
        pinRepeat: 'الرقم السري مجددا',
        pinNew: 'الرقم السري الجديد',
        changePin: 'تبديل الرقم السري',
        leadsManagment: 'ادارة الطلبات',
        reassignLeads: 'اعادة توزيع الطلبات',
        /////////////
        captcha:`الرجاء ادخال الرمز الموجود في الصورة`,
        wrong_captcha: `لقد قمت بادخال رمز خطا`,
        only_numbers: `يسمح بأدخال الارقام فقط`,
        progressTitle: `التقدم`,
        pdfReportsIconTooltip: `انشاء تقرير`,
        generateReport: `انشاء تقرير`,
        clearChart: `اعادة تعيين`,
        cant_be_imported: `لا يمكن استيراد هذا الموظف`,
        domain_not_allowed: `هذا النطاق غير مسموح به`,
        allLegend: `مفتاح العتبات`,
        specialAccess: `اعطاء المستخدم صلاحيات لعرض صفحات الوزارة`,
        email: `الايميل`,
        password: `كلمة السر`,
        login: `تسجيل الدخول`,
        send: `ارسال`,
        home: `الرئيسية`,
        max_retries: `تخطيت عدد المحاولات المسموحة`,
        wrong_code: `خطأ في كتابة الرمز، يرجى المحاولة مرة اخرى`,
        expired: `انهت صلاحية الجلسة`,
        user_already_exists: `تم استيراد هذا المستخدم سابقاً`,
        success: `تمت العملية بنجاح`,
        not_found: `العنصر غير موجود`,
        all_fields_required: `جميع الحقول مطلوبة`,
        item_name_missing: `احد العناصر ينقصه اسم`,
        organisation: `نظرة عامة على الوزارة`,
        strategy: `استراتيجية الوزارة`,
        orgProgress: `مقياس انجاز الوزارة`,
        orgStructure: `الهيكل التنظيمي للوزارة`,
        userSettings: `اعدادات المستخدم`,
        mySpace: `المساحة الشخصية`,
        notifications: `التنبيهات`,
        progress: `الاهداف والمنجزات`,
        reports: `التقارير`,
        report: `تقرير`,
        managment: `لوحة التحكم`,
        employees: `استيراد الموظفين`,
        employeesSub: `ادارة الموظفين`,
        charts: `الرسم البياني للأداء`,
        approvals: `موافقاتي`,
        user: `حسابي`,
        orgStructureSetting: `تعديل الهيكل التنظيمي`,
        settings: `اعدادات`,
        pubReports: `اصدار تقرير`,
        logout: `الخروج`,
        time: `الوقت`,
        forms:`الطلبات`,
        form_id:`FORM ID`,
        ////// progress
        search: `ابحث`,
        totalProgress:`اجمالي الانجازات`,
        goals:`الاهداف`,
        goal: `هدف`,
        keyResult:`نتيجة رئيسية`,
        keyResults:`نتائج رئيسية`,
        initiative:`مبادرة`,
        initiatives:`مبادرات`,
        trend: `التباين`,
        progress: `الاهداف والمنجزات الرئيسة`,
        mainResult: `النتائج/المبادرات`,
        status: `الحالة`,
        change: `تعديل`,
        editIconTooltip: `تعديل`,
        deleteIconTooltip: `مسح`,
        trending: {
          up:`تقدم`,
          down:`تراجع`,
          flat:`ثبات`
        },
        addGoal: `اضافة هدف`,
        addGoalTitle: `اضافة هدف`,
        editGoalTitle: `تعديل هدف`,
        parentGoal: `هدف علوي يرتبط به`,
        deleteGoalTitle: `مسح هدف`,
        addKeyResult: `اضافة نتيجة`,
        addKeyResultTitle: `اضافة نتيجة`,
        editKeyResultTitle: `تعديل نتيجة`,
        deleteKeyResultTitle: `مسح نتيجة`,
        addInit: `اضافة مبادرة`,
        addInitTitle: `اضافة مبادرة`,
        editInitTitle: `تعديل مبادرة`,
        deleteInitTitle: `مسح مبادرة`,
        viewGoalTitle: `تفاصيل الهدف`,
        viewKeyResultTitle: `تفاصيل النتيجة الرئيسية`,
        viewInitTitle: `تفاصيل المبادرة`,
        cancelBtn: `الغاء`,
        addBtn: `اضافة`,
        updateBtn: `تحديث`,
        add:`اضافة`,
        update:`تعديل`,
        delete:`مسح`,
        deleteMessage:`هل انت متأكد من ازالة هذا العنصر وكل ما يتعلق به بشكل نهائي؟`,
        startValue: `قيمة البداية`,
        targetValue: `قيمة الهدف`,
        unite: `وحدة القياس`,
        currentValue: `القيمة الحالية`,
        weight:`قيمة المساهمة`,
        quarter:`الربع`,
        meters: `متر`,
        dollar: `دولار امريكي`,
        riyal: `ريال سعودي`,
        rank: `ترتيب`,
        number: `عدد`,
        mbps: `Mbps`,
        gbps: `Gbps`,
        percentage:`%`,
        quarter_one: `الربع الاول`,
        quarter_two: `الربع الثاني`,
        quarter_three: `الربع الثالث`,
        quarter_four: `الربع الرابع`,
        required: `مطلوب`,
        upload: `تحميل ملف`,
        confidential: `سري`,
        normal: `عادي`,
        fileType: `نوع الملف`,
        files:`ملفات`,
        date: `التاريخ`,
        new: `جديد`,
        theVision: `الرؤية`,
        theMission: `المهمة`,
        theMessage: `الرسالة`,
        usersSettings: `اعدادات انواع المستخدمين`,
        updateUser: `تحديث المستخدم`,
        platformSettings: `اعدادات النظام`,
        thresholdSettings: `اعدادات العتبات`,
        uniteSettings: `اعدادات وحدات القياس`,
        fileTypeSettings: `اعدادات تصنيف سرية المستندات الداعمة`,
        allowedFilesSettings: `اعدادات انواع الملفات المسموحة`,
        AddThreshold:`اضافة عتبة`,
        name: `الاسم`,
        percentageWord: `النسبة`,
        saveSetting: `تخزين الاعدادات`,
        slug: `اسم التخزين (دون فراغ)`,
        arabic: `العربية`,
        english: `الانجليزية`,
        AddUnite: `اضافة وحدة`,
        hundredError: `يجب ان يكون اقل من 100`,
        AddFileType: `اضافة تصنيف`,
        
        
        addMainLevel: `اضافة منصب اساسي`,
        addBelow: `اضافة منصب فرعي`,
        phoneNumber: `رقم الهاتف`,
        importUser: `استيراد المستخدم وانشاء حساب`,
        employeeData: `معلومات الموظف`,
        employee: `الموظف`,
        accept: `موافقة`,
        type:`النوع`,
        reject: `رفض`,
        rejectMessage: `ملاحظة الرفض`,
        acceptedNotification: `تم الموافقة على`,
        rejectNotification: `تم رفض`,
        submissionNotification: `بحاجة للمراجعة`,
        deletionNotification: `تم مسح`,
        pending: `بانتظار المراجعة`,
        approved: `حصل على الموافقة`,
        there:`هناك`,
        createNewReport: `انشاء تقرير جديد`,
        dones: `انجازات`,
        todos: `خطط`,
        supports: `بحاجة دعم`,
        comments: `تعليقات`,
        reportName: `اسم التقرير`,
        fromDate: `من تاريخ`,
        toDate: `الى تاريخ`,
        newReportNotification: `تقرير جديد بعنوان`,
        by: `بواسطة`,
        submitReport: `تقديم التقرير`,
        deleteReport: `مسح التقرير`,
        updateReport: `تحديث التقرير`,
        uniteThresholds: `توحيد الاعدادات لجميع الفئات من المنجزات`,
        myReports: `تقاريري`,
        employeesReports: `تقارير الموظفين`,
        all: `الكل`,
        totals: `اجمالي الانجازات`,
        stepName: `اسم العتبة`,
        stepSettings: `اعدادات العتبة`,
        instituteSettings: `تعديل استراتيجية الوزارة`,
        lastSeen: `اخر تحديث`,
        getEmailNotifications: `الحصول على تنبيهات الأهداف و المنجزات و المبادرات عبر الايميل`,
        getReportsByEmail: `الحصول على تنبيهات التقارير عبر الايميل`,
        user_does_not_exist: `هذا المستخدم غير موجود`,
        viewIconTooltip: `الاطلاع على التفاصيل`,
        reportsIconTooltip: `الاطلاع على التقارير`,
        closeBtn: `اغلاق`,
        SMSCode: `الرمز المرسل في الرسالة النصية`,
      },
      fr:{

      }
    },
    modelMenu: [],
    menu:[],
    online:false,
    centralLogin:false,
    loginDialog:null,
    globalLoading:null,
    user: null,
    users:[],
    uid:null,
    language:'ar',
    notifications:[],
    approvals: [],
    settings: {
      baseUrl: ``,
      apiBase: ``,
      public: ``,
    },
    userRoles:[
      'user',
      'admin',
      'superadmin'
    ],
    usersLevels:[],
    reports:[],
  },
  modules: {

  },
  mutations: {
    
  },
  actions: {
    
  },
  getters: {
    
  }
});
